import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Field, FormSection, change } from 'redux-form';
import { connect } from 'react-redux';

@connect()
export default class AssumptionEditor extends Component {
  componentDidMount = () => {
    const {
      uid,
      dispatch,
      input,
    } = this.props;

    if (!input.value.description) {
      dispatch(change(uid, `${input.name}.description`, null));
    }
  };

  buildDescriptionField = (hiddenValue, fieldValue) => {
    if (!hiddenValue) return null;

    return (
      <div>
        <label
          className="mt-1 mb-0"
          style={{ fontFamily: 'Arial', fontSize: 14, padding: 0 }}
        >
          Tearing Explanation
        </label>
        <div className="input-group" style={{ padding: 0 }}>
          <Field
            component="textarea"
            className="form-control c-select d-inline-block"
            name="description"
            value={
              fieldValue && fieldValue.description
                ? fieldValue.description
                : null
            }
          />
        </div>
      </div>
    );
  };

  buildTearingField = (editorHidden) => {
    return (
      <div className="row">
        <label
          className="mt-1 mb-0 col-sm-3"
          style={{ fontFamily: 'Arial', fontSize: 14, padding: 0 }}
        >
          Torn
        </label>
        <div className="input-group col-sm-9" style={{ padding: 0 }}>
          <Field
            className="mt-2"
            name="hidden"
            component="input"
            type="checkbox"
            onChange={e => this.handleStatusOnChange(e.target.value)}
            parse={value => {
              return value === true ? true : false;
              }
            }
          />
        </div>
      </div>
    );
  };

  handleStatusOnChange = value => {
    const {
      uid,
      dispatch,
      input,
    } = this.props;

    if (value === 'true') {
      dispatch(change(uid, `${input.name}.description`, null));
    }
  };

  render() {
    const {
      input,
      wrapperClassName,
      wrapperStyle,
      containerClassName,
      containerStyle,
    } = this.props;

    const formSectionName = 'field';
    const fieldValue = input.value;
    const hiddenValue = fieldValue.hidden;

    const editorHidden = fieldValue && fieldValue.hidden
      ? fieldValue.hidden
      : null;

    return (
      <div>
        <div className={wrapperClassName} style={wrapperStyle}>
          <div className={containerClassName} style={containerStyle}>
            <FormSection name={formSectionName}>
              {this.buildTearingField(editorHidden)}
              {this.buildDescriptionField(hiddenValue, fieldValue)}
            </FormSection>
          </div>
        </div>
      </div>
    );
  }
}

AssumptionEditor.propTypes = {
  field: PropTypes.object,
  input: PropTypes.object,
  dispatch: PropTypes.func,
  uid: PropTypes.string,
  containerClassName: PropTypes.string,
  containerStyle: PropTypes.object,
  wrapperClassName: PropTypes.string,
  wrapperStyle: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/components/types/Assumption/AssumptionEditor.js